import { useMemo } from 'react';

import { t } from '@lingui/macro';

const useReadCheckoutPrice = (priceData, checkoutData) => {
  const { taxes, tax_excluded: priceTaxExcluded } = priceData;

  const { taxesLabel, taxesTotal } = useMemo(() => formatTaxes(taxes), [JSON.stringify(taxes)]);
  let vakarioFeeTotal = 0.0;
  let vakarioFeeLabel = '';

  if (checkoutData != null && checkoutData.vakario_fee_included === false) {
    vakarioFeeTotal = parseFloat(checkoutData.vakario_fee_full);
    // no label = no fee displayed
    if (vakarioFeeTotal > 0) {
      vakarioFeeLabel = t`Booking system fee (YoPlanning)`;
    }
  }

  const priceTaxIncluded = parseFloat(priceData.tax_included) + vakarioFeeTotal;
  return { priceTaxIncluded, priceTaxExcluded, taxesLabel, taxesTotal, vakarioFeeLabel, vakarioFeeTotal };
};

const formatTaxes = taxes => {
  let taxesLabel = '';
  let taxesTotal = 0.0;
  for (const key of Object.keys(taxes)) {
    taxesLabel += key + ', ';
    taxesTotal += parseFloat(taxes[key]);
  }
  taxesLabel = taxesLabel.length > 0 ? taxesLabel.substring(0, taxesLabel.length - 2) : null;
  return { taxesLabel, taxesTotal };
};

export default useReadCheckoutPrice;
